<template>
  <div id="tab-maneuvering">
    <component
      :is="scrollbarTag"
      class="scroll-area--customizer"
      :settings="settings"
      :key="$vs.rtl"
    >
      <ul>
        <li class="pt-2">
          <vs-row>
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-end"
              vs-w="3"
            >
              <span class="sdf-text-18-400-light-navy">操舵モード</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-end"
              vs-align="flex-end"
              vs-w="9"
            >
              <span class="sdf-text-18-400-white">{{
                  steeringMode || noneValue
                }}</span>
            </vs-col>
            <vs-divider :color="sdfColor.LightNavy"/>
          </vs-row>
          <vs-row>
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-end"
              vs-w="3"
            >
              <span class="sdf-text-18-400-light-navy">操縦モード</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-end"
              vs-align="flex-end"
              vs-w="9"
            >
              <span class="sdf-text-18-400-white">{{
                  maneuveringMode || noneValue
                }}</span>
            </vs-col>
            <vs-divider :color="sdfColor.LightNavy"/>
          </vs-row>
          <vs-row>
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-end"
              vs-w="4"
            >
              <span class="sdf-text-18-400-light-navy">主機FO流量合計</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-end"
              vs-align="flex-end"
              vs-w="8"
            >
              <span class="sdf-text-18-400-white"
              >{{ foFlowRateSumText }}</span
              >
            </vs-col>
          </vs-row>

          <vs-divider :color="sdfColor.LightNavy"/>

          <port-and-starboard-status
            v-bind:foFlowRateSum.sync="foFlowRateSum"
          />

          <vs-divider :color="sdfColor.LightNavy"/>

          <steering-status/>

          <vs-divider :color="sdfColor.LightNavy"/>

          <thruster-status/>
        </li>
      </ul>
    </component>
  </div>
</template>

<script>
import {
  ColorMixin,
  MappingTableMixin,
  StoreMonitoringVesselManeuveringMixin
} from "@/mixins/addon/secure-dataflow";

// components
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import SteeringStatus from "./steering-status/SteeringStatus";
import PortAndStarboardStatus from "./port-and-starboard-status/PortAndStarboardStatus";
import ThrusterStatus from "./thruster-status/ThrusterStatus";

export default {
  mixins: [
    ColorMixin,
    MappingTableMixin,
    StoreMonitoringVesselManeuveringMixin
  ],
  components: {
    VuePerfectScrollbar,
    SteeringStatus,
    PortAndStarboardStatus,
    ThrusterStatus
  },
  data() {
    return {
      settings: {
        suppressScrollX: true,
        maxScrollbarLength: 60,
        wheelSpeed: 1,
        swipeEasing: true
      },
      foFlowRate: {
        sum: null
      },
      foFlowRateSum: 0
    };
  },
  computed: {
    foFlowRateSumText() {
      if (this.foFlowsSum === null) return "---"
      return this.foFlowsSum === -1 ? "計算中" : `${this.foFlowsSum.toFixed(2)} L/h`
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    steeringMode() {
      if (this.channelDataManeuvering) {
        return `${this.getSteeringModeLabel(
          this.channelDataManeuvering.SB29.vs
        )}`;
      }
    },
    maneuveringMode() {
      if (this.channelDataManeuvering) {
        return `${this.getManeuveringModeLabel(
          this.channelDataManeuvering.SB30.vs
        )}`;
      }
    },
    currentTurningDialOperationAmountRight() {
      if (this.channelDataManeuvering) {
        return Number(this.channelDataManeuvering.SB33.vn.toFixed(0));
      }
    }
  },
  mounted() {
  }
};
</script>

<style lang="scss"></style>
